// Copyright (c) 2016 Deere & Company

import SelectedDealers, {getDefaultState as getSelectedDealersDefaultState} from './selected-dealers';
import WarrantyTypes, {getDefaultState as getWarrantyTypesDefaultState} from './warranty-types';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {getDefaultState as getDateRangeDefaultState} from './date-range';
import t from 'tcomb';

const Criteria = t.struct({
    expirationDate: DateRange,
    selectedDealers: SelectedDealers,
    warrantyTypes: WarrantyTypes
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        expirationDate: getDateRangeDefaultState(),
        selectedDealers: getSelectedDealersDefaultState(),
        warrantyTypes: getWarrantyTypesDefaultState()
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/state/criteria.js